var version = {
    "name":      "dativery",
    "buildDateCode": "20251215-231256",
    "buildDate": "Mon Dec 15 2025 23:12:56 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251215-231256",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;